import each from 'lodash/each';

import config from 'config';
import logger from '../../utils/logger';

class Adroll {
  constructor() {
    this.isFirstAdroll = true;
    this.ticks = 50;
    this.adrollInterval;
  }

  _append() {
    let scr = document.createElement('script'),
      host = (('https:' == document.location.protocol) ? 'https://s.adroll.com' : 'http://a.adroll.com');

    scr.setAttribute('async', 'true');

    scr.type = 'text/javascript';

    scr.src = host + '/j/roundtrip.js';

    ((document.getElementsByTagName('head') || [null])[0] || document.getElementsByTagName('script')[0].parentNode).appendChild(scr);
  }

  _awaitAdroll(id, advId, isPurchase) {
    return new Promise((resolve, reject) => {
      if (this.isFirstAdroll) {
        this.isFirstAdroll = false;

        window.adroll_pix_id = id;
        window.adroll_adv_id = advId;

        this._append();

        resolve();
      } else {
        clearInterval(this.adrollInterval);

        this.adrollInterval = setInterval(() => {
          this.ticks += 50;

          if (window.__adroll && window.__adroll._loaded) {
            window.__adroll = null;

            window.adroll_pix_id = id;
            window.adroll_adv_id = advId;

            this._append();

            this.ticks = 0;

            clearInterval(this.adrollInterval);

            resolve();
          } else if (this.ticks > 10000) {
            this.ticks = 0;

            clearInterval(this.adrollInterval);

            reject();
          }
        }, 50);
      }
    });
  }

  async _trackClient(infoGlobal, infoCampaign, order = {}) {
    let response,
      campaignName = order.campaign_name;

    if (infoCampaign.id && infoCampaign.adv_id) {
      try {
        response = await this._awaitAdroll(infoCampaign.id, infoCampaign.adv_id, campaignName);

        logger.log(`Client Adroll campaign specific id: ${infoCampaign.id} advertiser id: ${infoCampaign.adv_id} track event${campaignName ? ` for ${campaignName}` : ''}`);
      } catch (e) {
        logger.log(`Client Adroll campaign specific error, please make sure the pixel is configured correctly`);
      }
    } else {
      logger.log('Client Adroll campaign specific not configured');
    }

    if (infoGlobal.id && infoGlobal.adv_id && infoGlobal.id !== infoCampaign.id) {
      try {
        response = await this._awaitAdroll(infoGlobal.id, infoGlobal.adv_id, campaignName);

        logger.log(`Client Adroll global id: ${infoGlobal.id} advertiser id: ${infoGlobal.adv_id} track event${campaignName ? ` for ${campaignName}` : ''}`);
      } catch (e) {
        logger.log(`Client Adroll global error, please make sure the pixel is configured correctly`);
      }
    } else if (infoGlobal.id && infoGlobal.id === infoCampaign.id) {
      logger.log('Client Adroll global is the same as global.');
    } else {
      logger.log('Client Adroll global not configured.');
    }

    return response;
  }

  async trackVS() {
    try {
      let response = await this._awaitAdroll(config.ADROLL_PIX_ID, config.ADROLL_ADV_ID);

      logger.log(`VS Adroll pixel id: ${config.ADROLL_PIX_ID} advertiser id: ${config.ADROLL_ADV_ID} track event`);

      return response;
    } catch (e) {
      logger.log('VS Adroll error, please make sure the pixel is configured correctly');
    }
  }

  addToCart(vuex) {
    if (window.__adroll) {
      window.__adroll.record_user({
        product_id: vuex.rootState.sales.campaign.design_id,
        product_action: 'AddToCart',
      });
    }
  }

  clientViewSales({ state }) {
    return this._trackClient(state.campaign.tracking.global.adroll, state.campaign.tracking.campaign.adroll);
  }

  clientViewThankYou({ state }) {
    each(state.order.orders, order => {
      this._trackClient(state.order.tracking[order.analytics_cid].global.adroll, state.order.tracking[order.analytics_cid].campaign.adroll, order);
    });
  }
};

export default new Adroll();